(function () {
  "use strict";
  // Bewegung komplett: Zeit-Token lesen; Shopify liefert das CSS verkleinert aus (200ms wird .2s), daher Sekunden und Millisekunden
  function zdZeit(v) { v = String(v || '').trim(); var x = parseFloat(v); if (isNaN(x)) return NaN; return /ms$/i.test(v) ? x : (/s$/i.test(v) ? x * 1000 : x); }
  function zctT(k) { try { var el = document.getElementById('zct-texte'), d = el ? JSON.parse(el.textContent) : {}; var v = d[k]; if (typeof v === 'string' && v.indexOf('&') >= 0) { var t = document.createElement('textarea'); t.innerHTML = v; v = t.value; } return v == null ? '' : v; } catch (e) { return ''; } }

  if (window.__zctV17DesignSystem) return;
  window.__zctV17DesignSystem = true;

  var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
  var footerDesktop = window.matchMedia && window.matchMedia("(min-width: 769px)");
  var scheduled = false;

  function directSummary(details) {
    return details && details.querySelector(":scope > summary");
  }

  function closedHeight(details) {
    var summary = directSummary(details);
    if (!summary) return 0;
    var styles = window.getComputedStyle(details);
    return summary.getBoundingClientRect().height +
      parseFloat(styles.borderTopWidth || 0) +
      parseFloat(styles.borderBottomWidth || 0);
  }

  // ZCT_V21_ACCORDION (03.10.2026): Aufklapper nach Emil Kowalski. 200 ms, starkes ease-out, Höhe plus Einblenden
  // des Inhalts. Jederzeit unterbrechbar: ein neuer Klick startet von der aktuellen Höhe statt ignoriert zu werden.
  // Reduzierte Bewegung: keine Höhenbewegung, nur kurzes Einblenden.
  var ACC_EASE = "cubic-bezier(0.23, 1, 0.32, 1)";
  var ACC_MS = 200;
  // Bewegung komplett (Plan 006, 14.10.2026): ein Aufklapper für alle. Dauer und Kurve aus den Tokens in zct-v26.css
  // (Öffnen --zd-dauer-aufklapper 200 ms, Schließen --zd-dauer-aufklapper-zu 160 ms, --zd-kurve-aus), beim Klick sofort
  // data-zd-ziel="auf"|"zu" (Symbol und Beschriftung reagieren sofort statt nach der Animation), Gruppen unabhängig.
  function accToken(name, ersatz) { var v = window.getComputedStyle(document.documentElement).getPropertyValue(name); return (v && v.trim()) || ersatz; }
  function accMs(auf) { var v = zdZeit(accToken(auf ? "--zd-dauer-aufklapper" : "--zd-dauer-aufklapper-zu", "")); return isNaN(v) ? (auf ? 200 : 160) : v; }
  function accEase() { return accToken("--zd-kurve-aus", ACC_EASE); }

  function accContent(details) {
    return Array.prototype.filter.call(details.children, function (el) {
      return el.tagName !== "SUMMARY";
    });
  }

  function accTarget(details) {
    var state = details.__zctAcc;
    return state && state.anim ? state.target : details.open;
  }

  function accStop(details, state) {
    if (state.anim) {
      state.anim.cancel();
      state.anim = null;
    }
    if (state.fades) {
      state.fades.forEach(function (fade) { fade.cancel(); });
      state.fades = null;
    }
    details.style.removeProperty("overflow");
    details.style.removeProperty("box-sizing");
    delete details.dataset.zctAnimating;
  }

  function setOpen(details, shouldOpen) {
    if (!details) return Promise.resolve();
    var state = details.__zctAcc || (details.__zctAcc = {});
    details.dataset.zdZiel = shouldOpen ? "auf" : "zu";
    if (!state.anim && details.open === shouldOpen) return Promise.resolve();
    var content = accContent(details);

    if ((reducedMotion && reducedMotion.matches) || typeof details.animate !== "function") {
      accStop(details, state);
      details.open = shouldOpen;
      if (shouldOpen && typeof details.animate === "function") {
        content.forEach(function (el) {
          el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: zdZeit(accToken("--zd-dauer-klein", "150")) || 150, easing: "ease" });
        });
      }
      return Promise.resolve();
    }

    var wasOpen = details.open;
    var startHeight = details.getBoundingClientRect().height;
    var startOpacity = 0;
    if (wasOpen && content.length) {
      startOpacity = parseFloat(window.getComputedStyle(content[0]).opacity);
      if (isNaN(startOpacity)) startOpacity = 1;
    }
    accStop(details, state);

    if (shouldOpen) details.open = true;
    var endHeight = shouldOpen ? details.getBoundingClientRect().height : closedHeight(details);

    details.dataset.zctAnimating = "true";
    details.style.overflow = "hidden";
    details.style.boxSizing = "border-box";
    state.target = shouldOpen;
    var animation = details.animate(
      [
        { height: startHeight + "px" },
        { height: endHeight + "px" }
      ],
      { duration: accMs(shouldOpen), easing: accEase() }
    );
    state.anim = animation;
    state.fades = content.map(function (el) {
      return el.animate(
        [
          { opacity: startOpacity },
          { opacity: shouldOpen ? 1 : 0 }
        ],
        { duration: accMs(shouldOpen), easing: accEase(), fill: "forwards" }
      );
    });

    return animation.finished.then(function () {
      if (state.anim !== animation) return;
      if (!shouldOpen) details.open = false;
      accStop(details, state);
    }, function () {});
  }

  function enhanceGroup(detailsList, closeInitially, independent) {
    var group = Array.prototype.slice.call(detailsList || []);

    group.forEach(function (details) {
      if (!details || details.dataset.zctExclusiveAccordion === "true") return;
      var summary = directSummary(details);
      if (!summary) return;

      details.dataset.zctExclusiveAccordion = "true";
      if (closeInitially) details.open = false;

      summary.addEventListener("click", function (event) {
        if (details.classList.contains("zct-footer-static")) {
          event.preventDefault();
          details.open = true;
          return;
        }

        event.preventDefault();

        if (details.classList.contains("zct-footer-collapsible")) {
          details.dataset.zctFooterTouched = "true";
        }
        if (details.classList.contains("zct-footer-shop-more")) {
          event.stopPropagation();
          details.dataset.zctFooterTouched = "true";
        }

        // Plan 006: kein Zuklappen der anderen mehr – der angeklickte Kopf bleibt unter dem Finger (vorher rutschte er weg)
        setOpen(details, !accTarget(details));
      });
    });
  }

  // ZCT_V21_ACCORDION: FAQ- und „Mehr“-Aufklapper, die erst nach dem Laden (außerhalb von #root) eingefügt werden,
  // bekamen bisher keine Bewegung. Ein Klick-Listener am Dokument übernimmt alle, die noch nicht gebunden sind.
  function resourceGroupFor(details) {
    var faq = details.closest(".zct-seo-resource-faq, .zct-blog-faq");
    if (faq) return Array.prototype.slice.call(faq.querySelectorAll(":scope > details"));
    var intro = details.closest(".zct-v19-intro");
    if (intro) return Array.prototype.slice.call(intro.querySelectorAll("details"));
    var resource = details.closest(".zct-seo-resource");
    if (!resource) return null;
    return Array.prototype.slice.call(resource.querySelectorAll(resource.classList.contains("zct-v19-seo") ? ":scope > details" : "details"));
  }

  document.addEventListener("click", function (event) {
    var summary = event.target && event.target.closest ? event.target.closest("summary") : null;
    var details = summary && summary.parentElement;
    if (!details || details.tagName !== "DETAILS" || directSummary(details) !== summary) return;
    if (details.dataset.zctExclusiveAccordion === "true" || event.defaultPrevented) return;
    var group = resourceGroupFor(details);
    if (!group) return;
    event.preventDefault();
    setOpen(details, !accTarget(details));
  });

  function enhanceResourceAccordions() {
    document.querySelectorAll(".zct-v19-intro").forEach(function (intro) { enhanceGroup(intro.querySelectorAll("details"), false); });
    document.querySelectorAll(".zct-seo-resource").forEach(function (resource) {
      if (resource.classList.contains("zct-v19-seo")) {
        enhanceGroup(resource.querySelectorAll(":scope > details"), false);
        enhanceGroup(resource.querySelectorAll(".zct-seo-resource-faq details"), false);
      } else { enhanceGroup(resource.querySelectorAll("details"), false); }
    });
    document.querySelectorAll(".zct-blog-faq").forEach(function (faq) { enhanceGroup(faq.querySelectorAll(":scope > details"), false); });
    // Teil C (v26): kurze Aufklapper rechts auf der Produktseite (Versand, Rückgabe, Beratung) gleiten wie alle anderen (200 ms), unabhängig voneinander
    document.querySelectorAll(".zd-kurz").forEach(function (kurz) { enhanceGroup(kurz.querySelectorAll(":scope > details.zd-auf"), false, true); });
    // Plan 006: Journal-FAQ, Journal-Inhaltsverzeichnis (Handy) und Filtergruppen klappten bisher ohne Bewegung (nativ)
    enhanceGroup(document.querySelectorAll(".zct-j-faq details, details.zct-j-toc-mobile, .filters details.group"), false, true);
  }

  function enhanceFooterAccordions() {
    document.querySelectorAll("footer").forEach(function (footer) {
      var categoryDetails = Array.prototype.filter.call(
        footer.querySelectorAll("details"),
        function (details) {
          // ZCT_V21_ACCORDION: alle Footer-Aufklapper, nicht nur Shop und Kollektionen
          return !details.classList.contains("zct-footer-shop-more") &&
            !(details.parentElement && details.parentElement.closest("details"));
        }
      );

      var shopDetails = categoryDetails.filter(function (details) {
        var label = directSummary(details);
        return label && label.textContent.trim().toLowerCase() === "shop";
      })[0];
      var shopMore = shopDetails && shopDetails.querySelector(".zct-footer-shop-more");

      if (shopDetails && !shopMore) {
        var shopList = shopDetails.querySelector(":scope > ul");
        var shopItems = shopList ? Array.prototype.slice.call(shopList.children) : [];

        if (shopList && shopItems.length > 8) {
          var moreRow = document.createElement("li");
          var moreDetails = document.createElement("details");
          var moreSummary = document.createElement("summary");
          var closedLabel = document.createElement("span");
          var openLabel = document.createElement("span");
          var moreList = document.createElement("ul");

          moreRow.className = "zct-footer-shop-more-row";
          moreDetails.className = "zct-footer-shop-more";
          closedLabel.className = "zct-footer-shop-more-closed";
          openLabel.className = "zct-footer-shop-more-open";
          closedLabel.textContent = zctT("v25_mehr_anzeigen");
          openLabel.textContent = zctT("v25_weniger_anzeigen");

          moreSummary.appendChild(closedLabel);
          moreSummary.appendChild(openLabel);
          moreDetails.appendChild(moreSummary);
          moreDetails.appendChild(moreList);
          moreRow.appendChild(moreDetails);
          shopItems.slice(8).forEach(function (item) {
            moreList.appendChild(item);
          });
          shopList.appendChild(moreRow);
          shopMore = moreDetails;
        }
      }

      categoryDetails.forEach(function (details) {
        if (footerDesktop && footerDesktop.matches) {
          details.classList.remove("zct-footer-collapsible");
          details.classList.add("zct-footer-static");
          details.open = true;
        } else {
          details.classList.remove("zct-footer-static");
          details.classList.add("zct-footer-collapsible");
          if (details.dataset.zctFooterTouched !== "true") details.open = false;
        }
      });
      enhanceGroup(categoryDetails, false, true);
      if (shopMore) {
        if (shopMore.dataset.zctFooterTouched !== "true") shopMore.open = false;
        enhanceGroup([shopMore], false);
      }
    });
  }

  function enhanceCollectionSectionOrder() {
    document.querySelectorAll(".zct-seo-resource").forEach(function (resource) {
      var newsletter = document.getElementById("zct-inner-circle");
      if (!newsletter || newsletter.parentNode !== resource.parentNode) return;
      newsletter.classList.add("zct-collection-newsletter");
      newsletter.style.setProperty("display", "block", "important");
      newsletter.style.setProperty("width", "100%");
      if (newsletter.nextElementSibling !== resource) {
        resource.parentNode.insertBefore(newsletter, resource);
      }
    });
  }

  function splitSentences(text) {
    var cleanText = String(text || "").replace(/\s+/g, " ").trim();
    if (!cleanText) return [];

    if (window.Intl && window.Intl.Segmenter) {
      try {
        var language = document.documentElement.lang || "de";
        var segmenter = new window.Intl.Segmenter(language, { granularity: "sentence" });
        return Array.from(segmenter.segment(cleanText), function (part) {
          return part.segment.trim();
        }).filter(Boolean);
      } catch (error) {}
    }

    return (cleanText.match(/[^.!?]+(?:[.!?]+["'\u00bb\u201d)]*|$)/g) || [cleanText]).map(function (sentence) {
      return sentence.trim();
    }).filter(Boolean);
  }

  function setCollectionIntroOpen(wrapper, shouldOpen) {
    if (!wrapper) return;

    var panel = wrapper.querySelector(".zct-col-intro-more");
    var button = wrapper.querySelector(".zct-col-intro-toggle");
    var label = button && button.querySelector(".zct-col-intro-label");
    if (!panel || !button || !label) return;

    var openLabel = button.dataset.openLabel;
    var closedLabel = button.dataset.closedLabel;
    button.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
    label.textContent = shouldOpen ? openLabel : closedLabel;

    var state = wrapper.__zctAcc || (wrapper.__zctAcc = {});
    if ((reducedMotion && reducedMotion.matches) || typeof panel.animate !== "function") {
      if (state.anim) {
        state.anim.cancel();
        state.anim = null;
      }
      panel.hidden = !shouldOpen;
      if (shouldOpen && typeof panel.animate === "function") {
        panel.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 150, easing: "ease" });
      }
      return;
    }

    // ZCT_V21_ACCORDION: wie die anderen Aufklapper (200 ms, starkes ease-out, unterbrechbar)
    var startHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
    var startOpacity = panel.hidden ? 0 : parseFloat(window.getComputedStyle(panel).opacity);
    if (isNaN(startOpacity)) startOpacity = 1;
    if (state.anim) {
      state.anim.cancel();
      state.anim = null;
    }
    panel.hidden = false;
    var endHeight = shouldOpen ? panel.scrollHeight : 0;

    wrapper.dataset.zctAnimating = "true";
    panel.style.overflow = "hidden";
    var animation = panel.animate(
      [
        { height: startHeight + "px", opacity: startOpacity },
        { height: endHeight + "px", opacity: shouldOpen ? 1 : 0 }
      ],
      { duration: accMs(shouldOpen), easing: accEase() }
    );
    state.anim = animation;

    animation.finished.then(function () {
      if (state.anim !== animation) return;
      state.anim = null;
      if (!shouldOpen) panel.hidden = true;
      panel.style.removeProperty("overflow");
      delete wrapper.dataset.zctAnimating;
    }, function () {});
  }

  function enhanceCollectionIntros() {
    document.querySelectorAll(".col-hero > p").forEach(function (intro) {
      if (!intro || intro.dataset.zctCollectionIntro === "true") return;

      var originalText = intro.textContent.replace(/\s+/g, " ").trim();
      var sentences = splitSentences(originalText);

      // Short introductions already fit the intended 1-2 sentence layout.
      if (originalText.length <= 220 || sentences.length <= 2) {
        intro.dataset.zctCollectionIntro = "true";
        return;
      }

      var wrapper = document.createElement("div");
      var preview = document.createElement("p");
      var panel = document.createElement("div");
      var remainder = document.createElement("p");
      var button = document.createElement("button");
      var label = document.createElement("span");
      var icon = document.createElement("span");
      var panelId = "zct-col-intro-" + Math.random().toString(36).slice(2, 9);

      wrapper.className = "zct-col-intro";
      wrapper.dataset.zctCollectionIntro = "true";
      preview.className = "zct-col-intro-preview";
      preview.textContent = sentences.slice(0, 2).join(" ");
      panel.className = "zct-col-intro-more";
      panel.id = panelId;
      panel.hidden = true;
      remainder.className = "zct-col-intro-remainder";
      remainder.textContent = sentences.slice(2).join(" ");
      button.className = "zct-col-intro-toggle";
      button.type = "button";
      button.setAttribute("aria-controls", panelId);
      button.setAttribute("aria-expanded", "false");
      button.dataset.closedLabel = zctT("v25_mehr_lesen");
      button.dataset.openLabel = zctT("v25_weniger_anzeigen");
      label.className = "zct-col-intro-label";
      label.textContent = button.dataset.closedLabel;
      icon.className = "zct-col-intro-icon";
      icon.setAttribute("aria-hidden", "true");

      panel.appendChild(remainder);
      button.appendChild(label);
      button.appendChild(icon);
      wrapper.appendChild(preview);
      wrapper.appendChild(panel);
      wrapper.appendChild(button);
      intro.replaceWith(wrapper);

      button.addEventListener("click", function () {
        setCollectionIntroOpen(wrapper, button.getAttribute("aria-expanded") !== "true");
      });
    });
  }

  function collectSeoTopics(source) {
    var topics = [];
    var currentTopic = null;

    Array.prototype.slice.call(source ? source.childNodes : []).forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === "H2") {
        currentTopic = document.createElement("article");
        currentTopic.className = "zct-seo-topic";
        topics.push(currentTopic);
      }

      if (currentTopic) currentTopic.appendChild(node);
    });

    return topics;
  }

  function enhanceSeoTopicGrids() {
    document.querySelectorAll(".zct-seo-resource").forEach(function (resource) {
      if (resource.dataset.zctSeoTopicGrid === "true") return;

      var firstCopy = resource.querySelector(":scope > .zct-seo-resource-copy");
      var more = resource.querySelector(":scope > details.zct-seo-more");
      var moreCopy = more && more.querySelector(":scope > .zct-seo-resource-copy");
      if (!firstCopy || !more || !moreCopy) return;

      var firstSource = firstCopy.querySelector(":scope > .metafield-rich_text_field") || firstCopy;
      var topics = collectSeoTopics(firstSource).concat(collectSeoTopics(moreCopy));
      if (topics.length < 2) return;

      var primaryGrid = document.createElement("div");
      var moreGrid = document.createElement("div");
      primaryGrid.className = "zct-seo-topic-grid zct-seo-topic-grid-primary";
      moreGrid.className = "zct-seo-topic-grid zct-seo-topic-grid-more";

      topics.slice(0, 2).forEach(function (topic) {
        primaryGrid.appendChild(topic);
      });
      topics.slice(2).forEach(function (topic) {
        moreGrid.appendChild(topic);
      });

      firstCopy.textContent = "";
      moreCopy.textContent = "";
      firstCopy.appendChild(primaryGrid);
      moreCopy.appendChild(moreGrid);
      resource.dataset.zctSeoTopicGrid = "true";
    });
  }

  function enhance() {
    scheduled = false;
    enhanceCollectionSectionOrder();
    enhanceSeoTopicGrids();
    enhanceResourceAccordions();
    enhanceFooterAccordions();
    enhanceCollectionIntros();
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(enhance);
  }

  scheduleEnhance();
  document.addEventListener("DOMContentLoaded", scheduleEnhance, { once: true });
  window.addEventListener("pageshow", scheduleEnhance);
  window.setTimeout(scheduleEnhance, 250);
  window.setTimeout(scheduleEnhance, 900);

  if (footerDesktop) {
    if (footerDesktop.addEventListener) footerDesktop.addEventListener("change", scheduleEnhance);
    else if (footerDesktop.addListener) footerDesktop.addListener(scheduleEnhance);
  }

  var root = document.getElementById("root");
  if (root && window.MutationObserver) {
    new MutationObserver(scheduleEnhance).observe(root, { childList: true, subtree: true });
  }
})();

